module.exports = __webpack_public_path__ + "img/306.2b0d6a77.png";